import React from "react";
import KeyFun from "./img/key-function-new.svg";
import "./style.scss";
import { useTranslation } from 'react-i18next';
export default function MentorShipPlatform(props) {
  const keyData = props.data || [];
  const { t } = useTranslation();
  return (
    <div className="mentor-shhip-plattform">
      <section
        id="unique"
        className="mentor-platorfm"
      >
        <div className="w-100 pt-50 position-relative">
          <div className="container">
            <div className="row">
              <div className="sec-title text-center w-100 position-relative">
                <h2 className="mb-0 homepageFirstHeader">
                {t('Key_Functions_of_MAARG_Program')}
                  {/* Key Functions of MAARG Program */}
                </h2>
              </div>
            </div>
          </div>

          <div className="container" id="line">
            <div className="row wow fadeInDown">
              <div
                className="col-md-12 col-sm-6 col-lg-12 p-100"
              >
                <img src={KeyFun} className="w-100" />
              </div>
            </div>
          </div>
          <div class="container" style={{ maxWidth: "fit-content" }}>
            <div class="row pt-20 wow fadeInDown homekeysection">
              {keyData.map((data, key) => {
                return (
                  <div className="col" key={key}>
                    <div className="unique-sec">
                      <p className="homepageFirstDescription" style={{ fontSize: "20px" }}>{data}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
